import { CalendarStore } from "@/Appointments/Stores/CalendarStore";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class CalendarMiscHandler extends BaseOperationHandler {
    constructor() {
        super();
    }

    public InitCalendarTab(request: LocalEvent, store: CalendarStore): void {
        // do not reset everything to not lose current state of calendar when navigating between tabs

        // prevent cal reload on tab return PreventRefreshOnMount
        store.calendarActions.LoadCalendar(store.calendarModel, store.calendarDisplaySettingsModel, SubServerOperations.Calendar.SearchAppointments_ModificationReload);
    }
}

export { CalendarMiscHandler };
